import type { FaireThemeEntity } from "../../entity_types/theme";

export const boho_vintage_statement_pieces: FaireThemeEntity = {
  token: "boho-vintage-statement-pieces",
  type: "theme",
  name: "Boho-Vintage Statement Pieces",
  description: "Unique jewelry combining natural stones and vintage-inspired designs -- small-batch feel for a curated boutique.",
  teaser: "Bohemian statement pieces that stand out in your curated display.",
  detail: "Your store profile leans toward clothing and stylish accents. Bohemian styles stand out in a curated boutique environment -- featuring the Sabine Multi Stone Statement Ring and Chaplin Letter Bracelet.",
  bgColor: "#F5E6C8",
  exactProducts: true,
  retailerToken: "r_v79pcsx8up",
  productTokens: [
    "p_85zuvdfqvw",
    "p_ut3tbs6mrw",
    "p_pqf2f49nzz",
    "p_ufjavmwa64",
    "p_nrg5hxcuy3",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00Z",
    importedBy: "manual-v2-import",
  },
};
